
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { JobComplianceProductType } from '@/models/JobComplianceTypes';

extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    ValidationProvider,
  },
})
export default class LookupProductTypes extends Vue {
  @Prop({ type: Array, required: true }) public productTypes: JobComplianceProductType[];
  @Prop({ type: String, required: true }) public name: string;
  @Prop({ type: String, required: false }) public type_code: string;
  @Prop({ type: String, required: false, default: '' }) public variant: string;

  public loading = false;
  public productTypeValue = '';
  public selectItems: string[] = [];
  public showOptions = false;
  public arrowIdx = -1;

  public productTypeChosen: JobComplianceProductType = {
    code: '',
    description: '',
    default_length: 0,
    default_width: 0,
    default_height: 0,
    weight: 0,
  };
  private productTypeChosenDefault = { ...this.productTypeChosen };

  @Watch('type_code', { immediate: true })
  private watchPropTypeCode() {
    this.productTypeValue = this.type_code;
  }

  private applyValueFromParent(item): void {
    this.productTypeChosen = item;
    this.showOptions = false;
    this.productTypeValue = item.code;
    this.$forceUpdate();
  }

  public handleInput(evt: string): void {
    const filteredType: JobComplianceProductType[] = this.productTypes.filter(
      (x: JobComplianceProductType) => x.code.toUpperCase().indexOf(evt.toUpperCase()) >= 0,
    );
    this.selectItems = [...filteredType.map((item: JobComplianceProductType) => `${item.code} - ${item.description}`)];
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      const itemCode = this.selectItems[this.arrowIdx].split(' - ')[0];
      const chosenService = this.productTypes.find(x => x.code === itemCode);
      if (chosenService) {
        this.productTypeChosen = chosenService;
        this.showOptions = false;
        this.productTypeValue = itemCode;
        this.arrowIdx = -1;
        this.$emit('changed', this.productTypeChosen, this.name.split('-')[1], this.name.split('-')[2]);
      }
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public inputFocused(): void {
    this.showOptions = true;
    this.selectItems = this.productTypes.map((item: JobComplianceProductType) => `${item.code} - ${item.description}`);
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;
    }, 200);
  }

  public handleItemClick(item: string): void {
    const itemCode = item.split(' - ')[0];
    const productTypeChosen = this.productTypes.find((x: JobComplianceProductType) => x.code === itemCode);
    if (productTypeChosen) {
      this.productTypeChosen = productTypeChosen;
      this.showOptions = false;
      this.productTypeValue = itemCode;
      this.$emit('changed', productTypeChosen, this.name.split('-')[1], this.name.split('-')[2]);
    }
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }
}
